/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mt_remove_col = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`− Column`)
};

const es_mt_remove_col = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`− Columna`)
};

const de_mt_remove_col = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`− Spalte`)
};

const nl_mt_remove_col = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`− Kolom`)
};

const fr_mt_remove_col = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`− Colonne`)
};

const it_mt_remove_col = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`− Colonna`)
};

const pt_br2_mt_remove_col = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`− Coluna`)
};

const pt_mt_remove_col = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`− Coluna`)
};

const ja_mt_remove_col = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`− 列`)
};

const zh_mt_remove_col = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`− 列`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mt_remove_col = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mt_remove_col(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mt_remove_col", locale)
	if (locale === "en") return en_mt_remove_col(inputs)
	if (locale === "es") return es_mt_remove_col(inputs)
	if (locale === "de") return de_mt_remove_col(inputs)
	if (locale === "nl") return nl_mt_remove_col(inputs)
	if (locale === "fr") return fr_mt_remove_col(inputs)
	if (locale === "it") return it_mt_remove_col(inputs)
	if (locale === "pt-BR") return pt_br2_mt_remove_col(inputs)
	if (locale === "pt") return pt_mt_remove_col(inputs)
	if (locale === "ja") return ja_mt_remove_col(inputs)
	return zh_mt_remove_col(inputs)
};